import React, { useState, useEffect } from "react";
import { Filter, ShoppingCart } from "react-feather";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { Link } from "react-router-dom";
import { baseurl, imageUrl } from "../Baseurl";
import axios from "axios";
import noproduct from "../component/img/product_not_found.jpeg";
import { useParams } from "react-router-dom";
import { FaFilter } from "react-icons/fa";
const Search = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedConditions, setSelectedConditions] = useState([]);
  const [maxPrice, setMaxPrice] = useState(Infinity);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${baseurl}getNewProducts`);
      const productList = response.data?.data || [];
      setProducts(productList);
      setFilteredProducts(productList);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const { slug } = useParams();
  const [menuData, setMenuData] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");

  const [menus, setMenus] = useState([]);
  const [checkedCategories, setCheckedCategories] = useState([]);
  const [categoryLevels, setCategoryLevels] = useState([]); // to show level-wise checkboxes

  // Get all menus
  const fetchMenus = async () => {
    try {
      const response = await axios.get(`${baseurl}getMenus`);
      const data = response.data;
      setMenus(data);

      // Build top level menu
      const topLevel = data.filter(
        (menu) => menu.parent_id === null || menu.parent_id === 0
      );
      setCategoryLevels([{ level: 0, categories: topLevel }]);

      // Try to match slug to menu and trace back hierarchy
      const slugMenu = data.find((menu) => menu.slug === slug);
      if (slugMenu) {
        const hierarchy = [];
        let current = slugMenu;

        // Traverse back using parent_id
        while (current) {
          hierarchy.unshift(current.id);
          current = data.find((m) => m.id === current.parent_id);
        }

        setCheckedCategories(hierarchy);
        loadSubLevels(hierarchy, data);
      }
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };

  // Load sublevels for checked categories
  const loadSubLevels = (selectedIds, allMenus) => {
    let levels = [];
    let parentId = null;

    selectedIds.forEach((id, idx) => {
      const options = allMenus.filter((menu) => menu.parent_id === parentId);
      levels.push({ level: idx, categories: options });
      parentId = id;
    });

    const nextLevelOptions = allMenus.filter(
      (menu) => menu.parent_id === parentId
    );
    if (nextLevelOptions.length > 0) {
      levels.push({ level: levels.length, categories: nextLevelOptions });
    }

    setCategoryLevels(levels);
  };

  // Checkbox handler
  const handleCheckboxChange = (levelIndex, categoryId) => {
    const updatedChecked = [...checkedCategories.slice(0, levelIndex)];
    updatedChecked[levelIndex] = categoryId;

    setCheckedCategories(updatedChecked);
    loadSubLevels(updatedChecked, menus);
  };

  useEffect(() => {
    // fetchCategoryData();
    fetchMenus();
  }, [slug]);

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };

  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-2">
          {/* Filters */}
          <div className="col-md-2 hide-on-mobile">
            <h4 className="product-desc-title">
              Filters <Filter size={20} />
            </h4>
            <div className="filter-sidebar">
              {categoryLevels.map((level, index) => {
                // Determine the heading for the current level
                const heading =
                  index === 0
                    ? "What we do"
                    : menus.find((m) => m.id === checkedCategories[index - 1])
                        ?.title || `Level ${index + 1}`;

                return (
                  <div key={index} className="mb-2">
                    <div className="d-block mb-1 mnb1 text-start">
                      {heading}
                    </div>
                    {level.categories.map((cat) => (
                      <div key={cat.id}>
                        <Link
                          to={
                            cat.is_category
                              ? `/shop/${cat.slug}`
                              : `/searchs/${cat.slug}`
                          }
                          className="form-check text-start text-dark"
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`cat-${cat.id}`}
                            checked={checkedCategories[index] === cat.id}
                            onChange={() => handleCheckboxChange(index, cat.id)}
                          />
                          <label
                            htmlFor={`cat-${cat.id}`}
                            className="form-check-label text-capitalize"
                          >
                            {cat.title}
                          </label>
                        </Link>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Products */}
          <div className="col-md-10">
            <h4 className="product-desc-title">Shop Products</h4>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center vh-50">
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : (
              <div className="row g-2">
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <div className="col-md-3 col-6 " key={product.id}>
                      <div className="product-card">
                        <img
                          src={
                            product.listing_image
                              ? `${imageUrl}listing/${product.listing_image}`
                              : noproduct
                          }
                          alt={product.title}
                        />


  {/* {(() => {
    // pick the first non-video file
    const firstImage =
      product.images?.find(
        (img) => !img.toLowerCase().endsWith(".mp4") && !img.toLowerCase().endsWith(".webm")
      ) || noproduct;

    return (
      <img
        src={`${imageUrl}listing/${firstImage}`}
        alt={product.title}
      />
    );
  })()} */}

                        {/* <div className="text-start">
                          <span className="cntn">{product.condition}</span>
                        </div> */}

                        <div className="p-2">
<h3>{product.title}</h3>
                        <div className="price">
                          <span className="current-price">
                            {/* {convertPrice(product.price)} */}

                             {product.type !== "quoteRequest" && (
  <div className="price mb-2">
    <span className="current-price">
      {convertPrice(product.price)}
    </span>
  </div>
)}


                            {/* ₹ */}
                            {/* {Number(product.price).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })} */}
                          </span>
                        </div>
                        <Link
                          to={`/product/${product.slug}`}
                          className="btn add-to-cart"
                        >
                          <ShoppingCart size={16} />
                          &nbsp;
                          {product.type === "quoteRequest"
                            ? "View Details"
                            : "View Details"}
                        </Link>
                        </div>
                        
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center">
                    <img
                      src={noproduct}
                      className="img-fluid noproductimg"
                      alt="No Product Found"
                    />
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary cart-icon hide-on-desktop"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        Filter
      </button>

      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Filters <Filter size={20} />
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* <h4 className="product-desc-title">Filters <Filter size={20} /></h4> */}
              <div className="filter-sidebar">
                {categoryLevels.map((level, index) => {
                  const heading =
                    index === 0
                      ? "What we do"
                      : menus.find((m) => m.id === checkedCategories[index - 1])
                          ?.title || `Level ${index + 1}`;

                  return (
                    <div key={index} className="mb-2">
                      <div className="d-block mb-1 mnb1 text-start">
                        {heading}
                      </div>
                      {level.categories.map((cat) => (
                        <div key={cat.id}>
                          <a
                            href={
                              cat.is_category
                                ? `/shop/${cat.slug}`
                                : `/searchs/${cat.slug}`
                            }
                            target="_blank"
                            className="form-check text-start text-dark"
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`cat-${cat.id}`}
                              checked={checkedCategories[index] === cat.id}
                              onChange={() =>
                                handleCheckboxChange(index, cat.id)
                              }
                            />
                            <label
                              htmlFor={`cat-${cat.id}`}
                              className="form-check-label text-capitalize"
                            >
                              <a
                                href={
                                  cat.is_category
                                    ? `/shop/${cat.slug}`
                                    : `/searchs/${cat.slug}`
                                }
                                rel="noopener noreferrer"
                                className="text-dark text-decoration-none"
                              >
                                {cat.title}
                              </a>

                              {/* {cat.title} */}
                            </label>
                          </a>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="modal-footer">
              {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
               <FaFilter/> Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Search;
